import * as Constants from "utilities/Constant";
import "./registration-legal-consent.scss";

export const RegistrationLegalConsent = () => {
  return (
    <div className="registration-consent">
      <div className="registration-consent__wrapper">
        <p className="registration-consent--item">
          {Constants.Legal_Information_One}
          <a href={Constants.PRIVACYLINK} target="_blank" rel="noreferrer">
            Privacy Policy
          </a>
          {Constants.Legal_Information_Two}
          <a href={Constants.PARTNERSLINK} target="_blank" rel="noreferrer">
            partners
          </a>
          {Constants.Legal_Information_Three}
          {Constants.Legal_Information_Four}
          <a href={Constants.TERMSOFUSELINK} target="_blank" rel="noreferrer">
            Terms of Use
          </a>{" "}
          and{" "}
          <a href={Constants.AGREEMENTLINK} target="_blank" rel="noreferrer">
            Electronic Consent Agreement
          </a>
          {". "}
        </p>
        <p className="registration-consent--reader">{Constants.Assistant_Note}</p>
        <p className="registration-consent--reader">
          {Constants.Policy_Note}{" "}
          <a href={Constants.PRIVACYLINK} target="_blank" rel="noreferrer">
            Privacy Policy.
          </a>
        </p>
      </div>
    </div>
  );
};
